import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewFeaturesComponent } from './review-features.component';
import { ProductReviewsPipesModule } from '../pipes/product-reviews-pipes.module';

@NgModule({
  imports: [
    CommonModule,
		ProductReviewsPipesModule,
  ],
  declarations: [ReviewFeaturesComponent],
  exports: [ReviewFeaturesComponent],
})
export class ReviewFeaturesComponentModule {}